import { api } from '../client';

/**
 * Comandos enviados ao Traccar via `POST /api/commands/send`.
 *
 * Formato payload (custom command, p/ rastreadores GT06 e similares):
 *   {
 *     "deviceId": 43768,
 *     "type": "custom",
 *     "attributes": { "data": "RELAY,1#" },
 *     "textChannel": false
 *   }
 *
 * `type: 'custom'` envia o conteúdo de `attributes.data` como string crua pelo
 * canal IP (TCP) que o Traccar mantém aberto com o equipamento. Para enviar
 * via SMS, use `textChannel: true`.
 *
 * Esta é a ÚNICA rota de escrita liberada no guard read-only do client.
 */
export const commandsApi = {
  /** Envia um comando GT06 (texto cru) ao equipamento via canal IP. */
  send: (deviceId: number, data: string) =>
    api.post<unknown>('/commands/send', {
      body: {
        deviceId,
        type: 'custom',
        attributes: { data },
        textChannel: false,
      },
    }),
};

/** Comandos GT06 padrão usados na frota NautMax. */
export const GT06_COMMANDS = {
  block: 'RELAY,1#',
  unblock: 'RELAY,0#',
  position: 'POSITION#',
  reset: 'RESET#',
} as const;
